import { Typography, Box } from "@mui/material";
import { useLanguage } from "../../context/LanguageContext";
import { Colors } from "../../styles/theme";

const NoResults = () => {
  const { translate } = useLanguage();
  return (
    <Box
      display="flex"
      justifyContent="center"
      width="100%" 
    >
      <Typography variant="body1" color={Colors.primary}>
        {translate("no results found")}
      </Typography>
    </Box>
  );
};

export default NoResults;
